import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/views/LoginView.vue";
import otp from "@/views/otp.vue";
import Layout from "@/components/layout/Layout.vue";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: "Login",
        component: LoginView
    },
    {
        path: '/OTP',
        name: "OTP",
        component: otp
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue')
            },
            {
                path: 'view-logs',
                name: 'view-logs',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/LogsView.vue')
            },
            {
                path:'external-databases',
                name:'external-databases',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/ExternalDatabesView.vue')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach(async (to, from, next) => {
    if (!store.getters.isHydrated) {
        await new Promise((resolve) => {
            const interval = setInterval(() => {
                console.log(`is Hydrated`,store.getters.isHydrated)
                if (store.getters.isHydrated) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);  // Check every 50ms
        });
    }
    if (to.name !== `OTP` && to.name !== `Login`) {
        let sessionID = store.getters.getSessionID;
        console.log({sessionID})
        let exist = !!sessionID;
        if (!exist) {
            responses.showInfo(`User not detected , Please Login`);
            store.commit(`setAttemptedRoute`, to);
            next({name: "Login"});
            return;
        }
    }
    next();
});
export default router
